import { atom } from "recoil";

export const mealsTrackingStatusAtom = atom({
  key: "mealsTrackingStatus",
  default: null,
});

export default mealsTrackingStatusAtom;
